import { IoIosArrowRoundForward } from "react-icons/io";
import { IoIosArrowDown } from "react-icons/io";
import bg_hero_section_mobile from "../../../Assets/bg_hero_section_mobile.png";
import modelo_celular_mobile from '../../../Assets/modelo_celular_mobile.png'
import * as S from "./HeroSectionMobile.styles";

export const HeroSectionMobile = () => {
  const handleMenuClick = (sectionId) => {
    const el = document.getElementById(sectionId);
    if (el) {
      el.scrollIntoView({ behavior: "smooth" });
    }
  };

  return (
    <S.Wrapper>
      <S.WrapperContent>
        <div className="flex flex-col">
          <S.SubTitle>Unlock Brazil’s</S.SubTitle>

          <S.Title>$100B Digital Market</S.Title>

          <S.SubTitle>- In Real Time</S.SubTitle>

          <S.Text>
            Launch your business in Brazil with real-time, PIX-powered payins —
            fast, secure, and 100% compliant.
          </S.Text>

          {/*<S.BtnBox>
            <S.Btn
              onClick={() =>
                window.open(
                  "https://wa.me/5541999920109?text=Hello%2C%20I%20would%20like%20more%20information.",
                  "_blank"
                )
              }
              style={{
                zIndex: "1",
              }}
              className="
                bg-[var(--lime-500)]
                text-[var(--lime-800)]
                hover:bg-[var(--marine-50)]
                hover:text-[var(--lime-500)]
              "
            >
              Book a call
              <IoIosArrowRoundForward size={24} />
            </S.Btn>

            <S.Btn
              onClick={() =>
                window.open(
                  "https://wa.me/5541999920109?text=Hello%2C%20I%20would%20like%20more%20information.",
                  "_blank"
                )
              }
              style={{
                zIndex: "1",
              }}
              className="
                border
                border-[var(--lime-500)]
                bg-[var(--marine-50)]
                text-[var(--lime-500)]
                hover:bg-[var(--lime-500)]
                hover:text-[var(--marine-50)]
              "
            >
              Get Started
            </S.Btn>
          </S.BtnBox>*/}
        </div>
      </S.WrapperContent>

      <div
        className="
          bg-center
          bg-no-repeat
          bg-cover      
          flex
          items-center
          justify-center
          my-[64px]
        "
        style={{
          backgroundImage: `url(${bg_hero_section_mobile})`,
        }}
      >
        <img src={modelo_celular_mobile} alt="modelo_celular_mobile" />
      </div>

      <S.BtnOpportunityBox>
        <S.BtnOpportunity onClick={() => handleMenuClick("Opportunity")}>
          Explore the Opportunity
          <IoIosArrowDown size={24} />
        </S.BtnOpportunity>
      </S.BtnOpportunityBox>
    </S.Wrapper>
  );
};
